'use strict';

angular.module('cgmemApp')
  .config(function ($stateProvider) {
    $stateProvider
      .state('authenticated.syslog', {
        url: '/syslog',
        templateUrl: 'app/adminSysLog/adminSysLog.html',
        controller: 'AdminSysLogCtrl'
      });
  });